import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import { isHttpsUrl } from "./revisionRapidaSaludUtils";

const EMPTY_MATERIAL = {
  origen: "SHAREPOINT",
  nombre: "",
  descripcion: "",
  url: "",
  tipoDocumento: "",
  tamanoReportado: "",
  estado: "ACTIVO",
};

const MaterialDialog = ({ open, material, loading, apiError, onClose, onSave }) => {
  const [form, setForm] = useState(EMPTY_MATERIAL);
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    if (!open) return;

    setForm({
      ...EMPTY_MATERIAL,
      ...(material || {}),
      origen: material?.origen || "SHAREPOINT",
    });
    setValidationError("");
  }, [open, material]);

  const updateField = (field) => (event) => {
    setForm((current) => ({ ...current, [field]: event.target.value }));
    setValidationError("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!form.nombre.trim()) {
      setValidationError("El nombre del material es obligatorio.");
      return;
    }

    if (!isHttpsUrl(form.url)) {
      setValidationError("La URL debe ser HTTPS.");
      return;
    }

    onSave({
      nombre: form.nombre.trim(),
      descripcion: form.descripcion.trim(),
      origen: form.origen,
      url: form.url.trim(),
      tipoDocumento: form.tipoDocumento.trim(),
      tamanoReportado: form.tamanoReportado.trim(),
      ...(material ? { estado: form.estado } : {}),
    });
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>{material ? "Editar material" : "Agregar material"}</DialogTitle>
        <DialogContent>
          {(apiError || validationError) && (
            <Alert severity="error" sx={{ mb: 2 }}>{apiError || validationError}</Alert>
          )}
          <Grid container spacing={2} sx={{ pt: 0.5 }}>
            <Grid item xs={12} sm={6}>
              <TextField select fullWidth label="Fuente" value={form.origen} onChange={updateField("origen")} disabled={loading}>
                <MenuItem value="TEAMS">Teams</MenuItem>
                <MenuItem value="SHAREPOINT">SharePoint</MenuItem>
              </TextField>
            </Grid>
            {material && (
              <Grid item xs={12} sm={6}>
                <TextField select fullWidth label="Estado" value={form.estado} onChange={updateField("estado")} disabled={loading}>
                  <MenuItem value="ACTIVO">Activo</MenuItem>
                  <MenuItem value="INACTIVO">Inactivo</MenuItem>
                </TextField>
              </Grid>
            )}
            <Grid item xs={12}>
              <TextField fullWidth required label="Nombre o título" value={form.nombre} onChange={updateField("nombre")} disabled={loading} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth required label="URL" value={form.url} onChange={updateField("url")} placeholder="https://" disabled={loading} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Tipo de documento" value={form.tipoDocumento} onChange={updateField("tipoDocumento")} disabled={loading} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Tamaño reportado" value={form.tamanoReportado} onChange={updateField("tamanoReportado")} disabled={loading} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline minRows={2} label="Descripción" value={form.descripcion} onChange={updateField("descripcion")} disabled={loading} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>Cancelar</Button>
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? "Guardando..." : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default MaterialDialog;

